import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {AresResponse} from '../model/Entities/AresResponse';

@Injectable()
export class AresService extends ApiService<AresResponse> {

    protected apiUrl = 'api/ares';

    protected getObjectType(): any {
        return AresResponse;
    }

    getByIco(ic: string): Observable<AresResponse> {
        return this.sendGet(`${this.apiRoot}/${this.apiUrl}`, {ic: ic})
            .map((data) => this.objectResponseToCamelCase(data));
    }
}



// WEBPACK FOOTER //
// /app/src/services/ares.service.ts